module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/support-d4446b01fe4967874b1d6940e38622ad.png";